/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger,ScrollSmoother,SplitText,CustomEase,ScrollToPlugin);
import imagesLoaded from 'imagesloaded';
import Cookies from '../vendor/cookies';

export function homePageAnimation() {
  let smoother = ScrollSmoother.create();
  if (document.cookie.indexOf('first-visit') === -1) {

  } else {
    // Do Nothing
    $('body').removeClass('frozen');
    if(window.location.hash) {
      // Fragment exists
    } else {
      smoother.scrollTo("#home", true, "top top");
    }
  }

  if ($('body').hasClass('home')) {
    imagesLoaded(document.querySelector('.carousel'), function (instance) {
      var tl = gsap.timeline();
      CustomEase.create("zoom", ".2,0,.52,.99");

      // 1 - logo fades in
      tl.to('.hero__carouselLogo', {
        duration: '.5',
        opacity: '1',
        scale: '1'
      });

      // 2 - images scroll across
      tl.to('.carousel', {
        duration: 8,
        x: '-1500vw',
        ease: 'zoom'
      });

      // 3 -logo fades out
      tl.to('.hero__carouselLogo', {
        duration: '.25',
        delay: '0.4',
        opacity: '0',
        scale: '.7'
      });

      setTimeout(() => {
        // tl.add(controlVideo());
        $('body').removeClass('frozen');
        if (document.cookie.indexOf('first-visit') === -1) {
          Cookies.set('first-visit', 'first visit.', {
            expires: 3,
            path: '/'
          });
          smoother.scrollTo("#home", true, "top top");
        }
      }, 9500);

      tl.to('.siteHeader', {
        duration: '.35',
        y: '0',
        delay: 3
      });

    });
  }
}
